export const APP_URL = 'appUrl';
export const API_URL = 'apiUrl';
export const MSW_STATUS = 'mswStatus';

export const TEST_OBJECT = 'testObject';
